<div *ngIf="cardInfo() as cardInfo">
  <mat-card class="bottom-card">
    <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
      <div matCardAvatar *ngIf="showAvatar && !isCampaign()">
        <glxy-avatar [width]="AVATAR_WIDTH" icon="mail" backgroundColor="white" textColor="#9E9E9E"></glxy-avatar>
      </div>
      <div matCardAvatar *ngIf="showAvatar && isCampaign()">
        <glxy-avatar [width]="AVATAR_WIDTH" icon="campaign" backgroundColor="white" textColor="#9E9E9E"></glxy-avatar>
      </div>
      <mat-card-title>
        <span *ngIf="headerText() as headerText; else unknown" class="title">{{ headerText }}</span>
        <ng-template #unknown>
          <span class="title">{{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}</span>
        </ng-template>
      </mat-card-title>
      <mat-card-subtitle>
        <p *ngIf="cardInfo.effectiveDate !== null" class="effective-date">
          {{ cardInfo.effectiveDate | date : dateFormat }}
        </p>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
      <ng-container *ngIf="!isCampaign(); else campaign">
        <mat-card appearance="outlined" class="inner-card">
          <mat-card-title class="mat-card-title">
            <span class="title">{{ cardInfo.emailSubject }}</span>
          </mat-card-title>
          <mat-card-content class="content" [style.margin-left]="-(AVATAR_WIDTH - 36).toString() + 'px'">
            <div class="subtitle">
              <span *ngIf="cardInfo.emailDirection === 'outbound'">
                <div *ngIf="this.ownerName() as ownerName">
                  {{ ownerName }}
                </div>
                {{ 'ACTIVITY.EMAIL_TITLE.INBOUND' | translate }}
              </span>
              <span *ngFor="let contact of contactEmails(); last as lastContact">
                <a href="mailto:{{ contact }}" target="_blank" rel="noopener">{{ contact }}</a
                ><span *ngIf="!lastContact">, </span>
              </span>
            </div>
            <div *ngIf="cardInfo.emailBody">
              <crm-collapsible-section [maxHeightPx]="300">
                <span class="note-body" [innerHTML]="cardInfo.emailBody | iTrustThisHtml"></span>
              </crm-collapsible-section>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
      <ng-template #campaign>
        <span class="campaign-display">
          <span class="bolded">{{ cardInfo.emailSubject }}</span>
          {{ 'CONTACT.ACTIVITIES.CREATED_FROM' | translate }}
        </span>
        <span class="campaign-display bolded">
          <a href="{{ campaignLink() }}" target="_blank">{{ campaignName() }}</a>
        </span>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
